/**
 * Keycloak
 */

import { initKeycloak } from './keycloak';

/**
 * Types
 */

import type { Plugin } from 'vue';

const VueKeycloak: Plugin = {
  async install() {
    await initKeycloak({
      flow: 'hybrid',
      pkceMethod: 'S256',
      checkLoginIframe: true,
      onLoad: 'check-sso',
      silentCheckSsoRedirectUri:
        window.location.origin + '/silent-check-sso.html',
      silentCheckSsoFallback: true,
      enableLogging: import.meta.env.NODE_ENV !== 'production',
    });
  },
};

export { VueKeycloak };
